import * as React from 'react';
import Alert from '@mui/material/Alert';
import { Snackbar } from '@mui/material';

export const TRANSIENT_FEEDBACK_DURATION_MS = 4000;

export default function AlertComponent({ open, setOpen, text, severity, snack }) {
  return (
    snack ? (
      <Snackbar open={open} autoHideDuration={TRANSIENT_FEEDBACK_DURATION_MS} onClose={() => {setOpen(false)}}>
        <Alert
          onClose={() => {setOpen(false)}}
          severity={severity}
          sx={{ width: '100%' }}
        >
          {text}
        </Alert>
      </Snackbar>
      ) : (
        <Alert
          onClose={() => {setOpen(false)}}
          severity={severity}
          sx={{ width: '100%' }}
        >
          {text}
        </Alert>
      )
  );
}
